import React, { useEffect, useState } from "react";
import Head from "next/head";
import { NextSeo } from "next-seo";
import { getLanguage } from "localization/i8intl";
import { useWindowSize } from "api/commonConstants";
import { Container } from "react-bootstrap";
// import Link from "next/link";
import { useRouter } from "next/router";
import ElectionsWidget from "components/elections-2023/ElectionsWidget";
import { useContext } from "react";
// import getConfig from "next/config";
import { MasterConfigContext } from "constants/MasterConfigContext";
// import { FormattedMessage } from "react-intl";
import { baseUrl } from "api/constants";
import Tally from "components/tally/Tally";
import { stateData } from "constants/state";

function KaunJeetaD(props) {
  let electionsData = useContext(MasterConfigContext)?.[props.masterKey];
  

  // //uncomment it later
  // electionsData = {
  //   ...electionsData,
  //   electionYear : 2019

  // }

  // var electionYear = electionsData?.electionYear;
  var electionYear = electionsData?.electionYear_KJKH_listing;
  // var electionYear = 2020;

  const dryRun = electionsData?.dryRun;
  // var electionYear = ${displayYear};

  // const showProfilePage = electionsData?.showProfilePage;
  // var electionYear = ${displayYear}

  var displayYear = electionsData?.displayYear;

  const [language, setLanguage] = useState("");
  const [electionTopicData, setElectionTopicData] = useState([]);
  const router = useRouter();
  console.log(
    "calleddd2",

    router.asPath.charAt(0) === "/" ? router.asPath.substring(1) : router.asPath
  );

  const size = useWindowSize();

  useEffect(async () => {
    let dataFetched;
    const datas = await fetch(
      `${baseUrl}/web/postListByCategory/election?limit=5&skip=1&type=text,video,liveblog`
    );
    dataFetched = await datas?.json();
    dataFetched = dataFetched?.result?.entities;
    setElectionTopicData(dataFetched);
  }, []);
  useEffect(() => {
    setLanguage(getLanguage());
  }, []);
  const mainUrl = "all";

  const [winnersData, setWinnersData] = useState(props?.winnersData2024);
  const [prevData, setPrevData] = useState([]);

  async function getNewDataList() {
    await fetch(
      `https://akm-img-a-in.tosshub.com/sites/elections/${displayYear}/assembly/json/state-master/jammu-and-kashmir-${electionYear}-all-consituency.json`
    ).then(async (data) => {
      const data1 = await data.json();
      setWinnersData(data1?.seat_data);
    });
  }
  // useEffect(() => {
  //   if (electionYear == props.propData.currentYear) {
  //     getNewDataList();
  //   }
  // }, [electionYear]);
  const options = [
    {
      value: 0,
      label: "2019",
    },
    // {
    //   value: 2,
    //   label: '${displayYear}'
    // }
  ];
  const colorOptions = {
    llt: "#eb0e8c",
    tg: "#d9368b",
    mz: "#8ab3dc",
    mp: "#0c8a70",
    cg: "#2d8468",
    llt: "#d9368b",
    rj: "#fed029",
    up: "#f6523e",
    gj: "#f362b3",
    ct: "#B71F33",
    mt: "#f92929",
  };
  // async function getWinnersList() {
  //   await fetch(
  //     "https://akm-img-a-in.tosshub.com/sites/elections/${displayYear}/Vidhansabha/json/master/india-seat-wise-livedata-master.json"
  //   ).then(async (data) => {
  //     const data1 = await data.json();
  //     setWinnersData(data1?.data);
  //   });
  // }
  // useEffect(() => {
  //   getWinnersList();
  // }, []);
  useEffect(() => {
    if (winnersData?.length > 0) {
      setPrevData(winnersData);
    }
  }, [winnersData]);
  console.log("Winners data 2", props);
  function findSearchData(value) {
    const query = value.toLowerCase();
    const prevData = winnersData;
    const newData = prevData.filter(
      (item) =>
        item.ac_name.toLowerCase().includes(query) ||
        item.constitutency_hi.toLowerCase().includes(query) ||
        item.name.toLowerCase().includes(query)
    );
    setPrevData(newData);
  }
  function findSearchData2024(value) {
    const query = value.toLowerCase();
    const prevData = winnersData;
    const newData = prevData.filter(
      (item) =>
        item.seat_name.toLowerCase().includes(query) ||
        item.candidate_name.toLowerCase().includes(query)
    );
    setPrevData(newData);
  }
  useEffect(() => {
    setLanguage(getLanguage());
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };
      if (window.screen.width > 600) {
        googletag.cmd.push(function () {
          googletag
            .defineSlot(
              "/1007232/Lallantop_Desktop_ROS_ATF_728x90",
              [
                [728, 90],
                [970, 250],
                [970, 90],
              ],
              "div-gpt-ad-1701945163318-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/Lallantop_Desktop_ROS_MTF_1_728x90",
              [728, 90],
              "div-gpt-ad-1701945220410-1"
            )
            .addService(googletag.pubads());

          //  googletag.defineOutOfPageSlot('/1007232/Lallantop_Mobile_HP_Mweb_Interstitial',googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");
          googletag.enableServices();
        });
      } else {
        googletag.cmd.push(function () {
          googletag
            .defineSlot(
              "/1007232/Lallantop_Mobile_ROS_ATF_300x250",
              [
                [336, 280],
                [300, 250],
              ],
              "div-gpt-ad-1701946028239-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/Lallantop_Mobile_ROS_MTF_1_300x250",
              [
                [336, 280],
                [300, 250],
              ],
              "div-gpt-ad-1701946028239-1"
            )
            .addService(googletag.pubads());
            googletag
            .defineSlot(
              "/1007232/Lallantop_Mobile_HP_Bottom_320x50",
              [320, 50],
              "div-gpt-ad-1701946324333-0"
            )
            .addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");

          googletag.enableServices();
        });
      }
      googletag.pubads().refresh();
      // console.log("apstag", typeof apstag);
      // if (typeof apstag !== "undefined") {
      //   apstag.init({
      //     pubID: "7f0bbd82-5a13-48ec-9950-fcb028b1546c",
      //     adServer: "googletag",
      //     bidTimeout: 2e3,
      //   });
      //   // request the bids for the four googletag slots
      //   apstag.fetchBids(
      //     {
      //       slots: [

      //       ],
      //     },
      //     function (bids) {
      //       // set apstag bids, then trigger the first request to GAM
      //       googletag.cmd.push(function () {
      //         apstag.setDisplayBids();
      //         googletag.pubads().refresh();
      //       });
      //     }
      //   );
      // }
    }, 500);
  }, []);
  console.log("masterconfig ", props);

  return (
    <>
      <Head>
        <script
          id="my-script-detail"
          type="application/ld+json"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org/",
              "@type": "WebPage",
              name: `${props?.stateName} Assembly Election Result ${displayYear}: ${props?.stateName} Vidhan Sabha Parinam result in hindi | ${props?.stateHindi} विधानसभा रिजल्ट चुनाव`,
              description: `${props?.stateName} Chunav Result ${displayYear}: Know the latest updates of ${props?.stateName} assembly election result(${props?.stateHindi} विधानसभा रिजल्ट चुनाव ).
              जानिए ${props?.stateHindi} chunav में कौन चल रहा आगे और कौन पीछे? विधानसभा चुनाव नतीजे, विधानसभा चुनाव के रुझान और नतीजे, सबसे पहले यहां पढ़े.`,
              keywords: `${props?.stateName} Vidhan Sabha Chunav ${displayYear}, ${props?.stateName} election results,
          Vidhan Sabha election ${props?.stateName},
          ${props?.stateName} assembly election result,
          Chunav natije ${props?.stateName},
          ${props?.stateName} election ${displayYear},
          ${props?.stateName} assembly Election Updates in Hindi,
          ${props?.stateHindi} विधानसभा चुनाव,
          ${props?.stateHindi} विधानसभा रिजल्ट,
          ${props?.stateHindi} विधानसभा रिजल्ट ${displayYear}`,
              url: `${process.env.NEXT_PUBLIC_BASE_URL}${router.asPath}`,
              publisher: {
                "@type": "Organization",
                name: "The Lallantop",
                url: "https://www.thelallantop.com/",
                logo: {
                  "@type": "ImageObject",
                  url: "https://www.thelallantop.com/assets/images/lallatop-logo-m.svg",
                  width: 600,
                  height: 60,
                },
              },
            }),
          }}
        ></script>
        <script
          id="my-script-detail"
          type="application/ld+json"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  item: {
                    "@id": `${process.env.NEXT_PUBLIC_AUTH_URL}`,
                    name: `${"Home"}`,
                  },
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  item: {
                    name: `${"Election"}`,
                    "@id": `${process.env.NEXT_PUBLIC_AUTH_URL}election`,
                  },
                },
                {
                  "@type": "ListItem",
                  position: 3,
                  item: {
                    name: `${props?.stateName} Election Results`,
                    "@id": `${process.env.NEXT_PUBLIC_AUTH_URL}${
                      router.asPath.charAt(0) === "/"
                        ? router.asPath.substring(1)
                        : router.asPath
                    }`,
                  },
                },
              ],
            }),
          }}
        ></script>
        <script
          id="my-script-detail"
          type="application/ld+json"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "SiteNavigationElement",
              name: [
                "होम",
                "चुनाव",
                "न्यूज़",
                "एंटरटेनमेंट",
                "ऑडनारी",
                "टेक्नोलॉजी",
                "पड़ताल",
                "बिज़नेस",
                "लल्लनख़ास",
                "स्पोर्ट्स",
                "रंगरूट",
              ],
              url: [
                "https://www.thelallantop.com/",
                "https://www.thelallantop.com/election",
                "https://www.thelallantop.com/news",
                "https://www.thelallantop.com/entertainment",
                "https://www.thelallantop.com/oddnaari",
                "https://www.thelallantop.com/technology",
                "https://www.thelallantop.com/factcheck",
                "https://www.thelallantop.com/business",
                "https://www.thelallantop.com/lallankhas",
                "https://www.thelallantop.com/sports",
                "https://www.thelallantop.com/education",
              ],
            }),
          }}
        ></script>
        <link
          rel="preconnect"
          crossOrigin="true"
          href="https://static.chartbeat.com"
        ></link>

        <script
          async
          dangerouslySetInnerHTML={{
            __html: `
            (function () {
              var _sf_async_config = window._sf_async_config = (window._sf_async_config || {});
              _sf_async_config.uid = 60355;
              _sf_async_config.domain = 'thelallantop.com';
              _sf_async_config.useCanonical = true;
              _sf_async_config.useCanonicalDomain = true;
              _sf_async_config.sections = 'home'; 
              _sf_async_config.authors = '';
              function loadChartbeat() {
                  var e = document.createElement('script');
                  var n = document.getElementsByTagName('script')[0];
                  e.type = 'text/javascript';
                  e.async = true;
                  e.src = '//static.chartbeat.com/js/chartbeat.js';
                  n.parentNode.insertBefore(e, n);
              }
              loadChartbeat();
          })();
       `,
          }}
          strategy="afterInteractive"
          id="chartbeat"
          type="text/javascript"
        ></script>
      </Head>
      <NextSeo
        title={`${props?.stateName} Assembly Election Result ${displayYear}: ${props?.stateName} Vidhan Sabha Parinam result in hindi | ${props?.stateHindi} विधानसभा रिजल्ट चुनाव`}
        description={`${props?.stateName} Chunav Result ${displayYear}: Know the latest updates of ${props?.stateName} assembly election result(${props?.stateHindi} विधानसभा रिजल्ट चुनाव ).
जानिए ${props?.stateHindi} chunav में कौन चल रहा आगे और कौन पीछे? विधानसभा चुनाव नतीजे, विधानसभा चुनाव के रुझान और नतीजे, सबसे पहले यहां पढ़े.`}
        canonical={`${process.env.NEXT_PUBLIC_BASE_URL}${router.asPath}`}
      />
      <meta
        name="keywords"
        content={`${props?.stateName} Vidhan Sabha Chunav ${displayYear}, ${props?.stateName} election results,
          Vidhan Sabha election ${props?.stateName},
          ${props?.stateName} assembly election result,
          Chunav natije ${props?.stateName},
          ${props?.stateName} election ${displayYear},
          ${props?.stateName} assembly Election Updates in Hindi,
          ${props?.stateHindi} विधानसभा चुनाव,
          ${props?.stateHindi} विधानसभा रिजल्ट,
          ${props?.stateHindi} विधानसभा रिजल्ट ${displayYear}`}
      />
      {size.width > 600 ? (
        <div>
          {size.width >= 600 && (
            <div
              style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {router.asPath.includes("election") && (
                <div style={{ position: "relative" }}>
                  <img
                    src={"/assets/images/election-background-3.png"}
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "298px",
                    }}
                  ></img>
                  <img
                    src="/assets/images/left-election-top-2.png"
                    width=""
                    height="170px"
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "10px",
                    }}
                  ></img>
                  <img
                    src={
                      router.asPath.includes("haryana-assembly")
                        ? "/assets/images/right-election-top-2.png"
                        : router.asPath.includes("jammu-kashmir-assembly")
                        ? "/assets/images/jammu-kashmir.png"
                        : "/assets/images/indian-map.png"
                    }
                    width=""
                    height="250px"
                    style={{ position: "absolute", bottom: "0", right: "0px" }}
                  ></img>
                </div>
              )}
              <Container
                align="center"
                style={{
                  position: router.asPath.includes("/election")
                    ? "absolute"
                    : "relative",
                  top: router.asPath.includes("/election") ? "22px" : "0px",
                }}
              >
                {/* <Ads
            adName={"/1007232/Lallantop_ROS_728x90_300x250"}
            keyBindings={{
              category: [router.query?.categoryName],
              keywords: metaTags[category]?.metaKeyword,
            }}
          /> */}

                <div className="container-row py-2" align="center">
                  <p
                    style={{
                      fontSize: "11px",
                      color: "#b7b7b7",
                      textAlign: "center",
                      marginBottom: "0px",
                    }}
                  >
                    Advertisement
                  </p>
                  <div
                    id="div-gpt-ad-1701945163318-0"
                    style={{
                      minWidth: "300px",
                      minHeight: "100px",
                      display: "block !important",
                      alignContent: "center",
                      textAlign: "-webkit-center",
                    }}
                    className="ads-auto-resize"
                  >
                    <script
                      type="text/javascript"
                      dangerouslySetInnerHTML={{
                        __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945163318-0')})`,
                      }}
                    ></script>
                  </div>
                </div>
              </Container>
            </div>
          )}
        </div>
      ) : (
        <div>
          <div style={{ position: "relative", width: "100%" }}>
            <img
              src={"/assets/images/election-background-mobile.png"}
              style={{ position: "relative", width: "100%", height: "auto" }}
            ></img>
            <img
              src="/assets/images/election-left-mobile.png"
              width=""
              height="70px"
              style={{ position: "absolute", bottom: "10px", left: "10px" }}
            ></img>
            <img
              src={
                router.asPath.includes("haryana-assembly")
                  ? "/assets/images/right-election-top-2.png"
                  : router.asPath.includes("jammu-kashmir-assembly")
                  ? "/assets/images/jammu-kashmir.png"
                  : "/assets/images/indian-map.png"
              }
              width=""
              height="90px"
              style={{ position: "absolute", bottom: "0", right: "0px" }}
            ></img>
          </div>
        </div>
      )}

      {/* desktop bread crump  */}
      {size.width > 768 ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              backgroundColor: "white",
              width: "max-content",
              margin: "auto",
              gap: "68px",
              height: "80px",
              marginTop: "15px",
              borderRadius: "12px",
              padding: "0px 30px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                // paddingTop: "1rem",
                gap: "8px",
                // cursor: "pointer",
                backgroundColor: "white",
                paddingLeft: "0px",
              }}
              // onClick={() =>
              //   window.open("/election/lok-sabha-chunav-${displayYear}", "_self")
              // }
            >
              {/* <div
              style={{ fontSize: "35px", fontWeight: "700", color: "white" }}
            >
              चुनाव
            </div> */}
              <img
                src="/assets/images/assembly-chunav.png"
                width="408.56px"
                height="58.21px"
                style={{ alignSelf: "center" }}
              ></img>
            </div>
            <div
              class="divCategoriesSchedule2 snipcss-eqdpv"
              style={{
                margin: "0px 0px",
                // backgroundColor: "rgb(217, 54, 139)",
                paddingLeft: "15px",
                alignContent: "center",
              }}
            >
              {/* dynamic breadcrump  */}
              {props.breadCrump.length > 0 &&
                props.breadCrump.map((item, index) => {
                  return electionsData[item.keyToShow] != false ? (
                    <a key={index} href={item.url}>
                      <span>{item.displayText}</span>
                    </a>
                  ) : null;
                })}
            </div>
          </div>
        </>
      ) : (
        // mobile breadcrump
        <>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                paddingTop: "1rem",
                gap: "8px",
                // cursor: "pointer",
                paddingBottom: "1rem",
                backgroundColor: "white",
                marginTop: "10px",
              }}
              // onClick={() =>
              //   window.open("/election/lok-sabha-chunav-${displayYear}", "_self")
              // }
            >
              <img
                src="/assets/images/assembly-chunav.png"
                width="240px"
                height="auto"
                style={{ alignSelf: "center" }}
              ></img>
            </div>
            <div
              class="divCategoriesSchedule2 snipcss-eqdpv"
              style={{
                margin: "-1px 0px",
                backgroundColor: "white",
                paddingLeft: "15px",
                paddingBottom: "1rem",
                display: "flex",
                justifyContent: "",
              }}
            >
              {/* dynamic breadcrump  */}
              {props.breadCrump.length > 0 &&
                props.breadCrump.map((item, index) => {
                  return electionsData[item.keyToShow] != false ? (
                    <a key={index} href={item.url}>
                      <span>{item.displayText}</span>
                    </a>
                  ) : null;
                })}
            </div>
          </div>
        </>
      )}

      <br></br>
      {/* outer breadcrump  */}
      {/* 
      {electionsData.HRExittally && (
            <>
            {size.width < 768 ? <div className="result-page">
              <h2
                style={{
                  fontSize: "27px",
                  color: "#D9368B",
                  fontWeight: "800",
                }}
              >
                विधानसभा एग्ज़िट पोल
              </h2>
              <div>
                <iframe
                  src={`${electionsData.HRExittally_URL}`}
                  width="100%"
                  height={electionsData.Exitpolltally_height_mobile}
                ></iframe>
              </div>
            </div> :   <div className="result-page">
              <h2
                style={{
                  fontSize: "27px",
                  color: "#D9368B",
                  fontWeight: "800",
                }}
              >
                विधानसभा एग्ज़िट पोल
              </h2>
              <div>
                <iframe
                  src={`${electionsData.HRExittally_URL}`}
                  width="100%"
                  height={electionsData.Exitpolltally_height_web}
                ></iframe>
              </div>
            </div>}
          
            </>
          )}
          {electionsData.HRresulttally && (
            <>
            {size.width < 768 ?   <div className="result-page-big">
              <h2
                style={{
                  fontSize: "27px",
                  color: "#D9368B",
                  fontWeight: "800",
                }}
              >
                विधानसभा रिजल्ट
              </h2>
              <div>
                <iframe
                  src={electionsData.HRresulttally_URL}
                  width="100%"
                  height={electionsData.Resulttally_height_mobile}
                ></iframe>
              </div>
            </div> :   <div className="result-page-big">
              <h2
                style={{
                  fontSize: "27px",
                  color: "#D9368B",
                  fontWeight: "800",
                }}
              >
                विधानसभा रिजल्ट
              </h2>
              <div>
                <iframe
                  src={electionsData.HRresulttally_URL}
                  width="100%"
                  height={electionsData.Resulttally_height_web}
                ></iframe>
              </div>
            </div>}
          
            </>
          )} */}

{size.width <= 768 && 
        (
          <div className="container-row py-2" align="center">
            <p
              style={{
                fontSize: "11px",
                color: "#b7b7b7",
                textAlign: "center",
                marginBottom: "0px",
              }}
            >
              Advertisement
            </p>
            <div
              id="div-gpt-ad-1701946028239-0"
              style={{
                minWidth: "300px",
                minHeight: "260px",
                display: "block !important",
                alignContent: "center",
                textAlign: "-webkit-center",
              }}
              className="ads-auto-resize"
            >
              <script
                type="text/javascript"
                dangerouslySetInnerHTML={{
                  __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})`,
                }}
              ></script>
            </div>
          </div>
        )}
      <Tally
        stateName={stateData[props.electionState].tallyState}
        masterConfig={electionsData}
      />
      <ul
        className="breadcrumb assembly-breadcrumb"
        style={{ margin: "auto", marginBottom: "20px" }}
      >
        <li>
          <a href="/" passHref>
            <a aria-label="Lallantop Home">
              <i className="icon-cat-home"></i>
              <span>Home</span>
            </a>
          </a>
        </li>
        <li>
          <a href="/election/" passHref>
            <a aria-label="Lallantop Home">
              <span>Election</span>
            </a>
          </a>
        </li>

        {
          <li>
            <span> {props.stateName} Election Results</span>
          </li>
        }
      </ul>
      <ElectionsWidget />

      <div className="lok-sabha-main">
        <div className="header-category-page">
          {/* {size.width > 768 && (
            <div>
              <div class="divCategoriesSchedule snipcss-eqdpv">
               
                {publicRuntimeConfig?.electionResultToggle && (
                  <a href="/election/vidhan-sabha-chunav-${displayYear}/party-wise-result">
                    <span>विधान सभा रिजल्ट</span>
                  </a>
                )}
                {publicRuntimeConfig?.electionResultToggle && (
                  <a href="/election/lok-sabha-chunav-${displayYear}/party-wise-result">
                    <span>लोक सभा रिजल्ट</span>
                  </a>
                )}
                {publicRuntimeConfig?.keyCandidate && (
                  <a href="/election/lok-sabha-chunav-${displayYear}/key-candidates">
                    <span>प्रमुख उम्मीदवार</span>
                  </a>
                )}
                {publicRuntimeConfig?.electionExitPollToggle === true && (
                  <a href="/election/lok-sabha-chunav-${displayYear}/exit-poll">
                    <span>एग्जिट पोल</span>
                  </a>
                )}
                <a href="/election/lok-sabha-chunav-${displayYear}/schedules">
                  <span>शेड्यूल</span>
                </a>{" "}
              </div>
            </div>
          )} */}
        </div>

        {/* <h1 style={{ display: "none" }}>Winning candidates list of Vidhan Sabha Election 2019 Constituency </h1> */}
        <h1>
          {props?.propData?.stateHindi} विधानसभा चुनाव रिजल्ट {displayYear}
        </h1>
        {electionYear != props.propData.currentYear ? (
          <div style={{ fontSize: "18px" }}>{props.propData.otherYearPara}</div>
        ) : (
          <div style={{ fontSize: "18px" }}>
            {props.propData.currentYearPara}
          </div>
        )}

        
        <br></br>
        {console.log("All props ", props)}
        <h3
          className="winner-box-header"
          style={{
            fontWeight: 600,
            borderColor: colorOptions["llt"],
            fontSize: "26px",
          }}
        >
          {electionYear} विधानसभा रिजल्ट{" "}
        </h3>
        <div className="result-page">
          {/* <div>
        <h1>
          Vidhan Sabha Election 2019 Constituency Wise Winning Candidates List
        </h1>
      </div> */}
          <div className="tp-data"></div>
          <div className="winners-list-box">
            <h2 style={{ fontSize: "22px", fontWeight: "700" }}>
              निर्वाचन क्षेत्र और उम्मीदवार
            </h2>
            <div className="assembly-buttons">
              {props.propData.tabs.map((item) => {
                return electionsData?.[item.showKey] !== false ? (
                  <div
                    onClick={() => {
                      window.location.href = item.url;
                    }}
                    className={
                      item.showActive
                        ? "assembly-buttons-btn-active"
                        : "assembly-buttons-btn"
                    }
                  >
                    {item.text}
                  </div>
                ) : null;
              })}
              {/* <div
                onClick={() => {
                  if (props.stateName !== "Haryana") {
                    window.location.href =
                      "/election/haryana-assembly-chunav/results";
                  }
                }}
                className={
                  props.stateName === "Haryana"
                    ? "assembly-buttons-btn-active"
                    : "assembly-buttons-btn"
                }
              >
                हरियाणा
              </div>
              {electionsData?.JK_KaunJeeta && (
                <div
                  onClick={() => {
                    if (props.stateName !== "Jammu and Kashmir") {
                      window.location.href =
                        "/election/jammu-kashmir-assembly-chunav/results";
                    }
                  }}
                  className={
                    props.stateName === "Jammu and Kashmir"
                      ? "assembly-buttons-btn-active"
                      : "assembly-buttons-btn"
                  }
                >
                  जम्मू कश्मीर
                </div>
              )} */}
            </div>
            <div>
              <br></br>
              <div class="search_cont snipcss0-0-0-1 snipcss-rNdJP">
                {" "}
                <input
                  type="text"
                  id="winner_list"
                  placeholder="Search for names.."
                  title="Type in a name"
                  autocomplete="off"
                  class="snipcss0-1-1-2"
                  onChange={(e) => {
                    if (electionYear == props.propData.currentYear) {
                      findSearchData2024(e.target.value);
                    } else {
                      findSearchData(e.target.value);
                    }
                  }}
                />{" "}
              </div>
            </div>
            {/* <br></br> */}
            <div
              style={{
                width: "100%",
                overflow: "auto",
              }}
            >
              <table
                style={{
                  tableLayout: "fixed",
                }}
              >
                <th style={{ backgroundColor: colorOptions["llt"] }}>
                  निर्वाचन क्षेत्र
                </th>
                <th style={{ backgroundColor: colorOptions["llt"] }}>पार्टी</th>
                <th style={{ backgroundColor: colorOptions["llt"] }}>विजेता</th>

                {/* data of the other year  */}
                {electionYear != props.propData.currentYear &&
                  prevData.map((con, index) => {
                    return (
                      <tr
                        key={index}
                        className={index % 2 !== 0 ? "oddColor" : ""}
                        style={{
                          letterSpacing: "normal",
                          fontSize: "18px",
                          width: "50%",
                        }}
                      >
                        <td
                          onClick={() =>
                            window.open(
                              `${process.env.NEXT_PUBLIC_BASE_URL}${
                                router.asPath
                              }/${con?.ac_name
                                .toLowerCase()
                                .replace(/[^a-zA-Z ]/g, "")
                                .split(" ")
                                .join("-")}-constituency-result/${con?.id}`,
                              "_self"
                            )
                          }
                          style={{
                            textAlign: "center",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          {`${con?.constitutency_hi} `}
                          {/* {`${con?.constitutency_hi} (${con?.ac_name})`} */}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            style={{
                              display: "inline-block",
                            }}
                          >
                            <img
                              src={con?.party_logo}
                              style={{ marginRight: "20px" }}
                              width="20px"
                              height="20px"
                            ></img>
                          </div>
                          <div
                            style={{
                              display: "inline-block",
                            }}
                          >
                            {con?.filter_party}
                          </div>
                        </td>
                        <td
                          // onClick={() =>{

                          //   electionsData.ShowProfileFromListing ?
                          //   window.open(
                          //     `${process.env.NEXT_PUBLIC_BASE_URL}/election/${
                          //       props?.electionState
                          //     }/candidate-${(
                          //       con?.candidate_name || con?.name
                          //     )
   
                          //       ?.toLowerCase()
                          //       .replace(/[^a-zA-Z ]/g, "")
                          //       .split(" ")
                          //       .join("-")}-${
                          //       con?.id}`,
                          //     "_self"
                          //   ) : ""
                          // }
                          // }
                          className="winner-name"
                          style={ false && electionsData?.ShowProfileFromListing ? {
                            textAlign: "center",
                            cursor: "pointer",
                            textDecoration: "underline",
                            fontSize: "18px" 
                          }    :   { textAlign: "center", fontSize: "18px" }}
                        >
                          {con?.name}
                        </td>
                      </tr>
                    );
                  })}


                {/* data of the current year  */}

                {electionYear == props.propData.currentYear &&
                  winnersData?.length > 0 &&
                  prevData.map((con, index) => {
                    return (
                      <>
                        {size.width < 768 ? 
                        (
                          <tr
                            key={index}
                            className={index % 2 !== 0 ? "oddColor" : ""}
                            style={{
                              letterSpacing: "normal",
                              fontSize: "15px",
                            }}
                          >
                            <td
                              onClick={() =>
                                window.open(
                                  `${process.env.NEXT_PUBLIC_BASE_URL}${
                                    router.asPath
                                  }/${con?.seat_name
                                    .toLowerCase()
                                    .replace(/[^a-zA-Z ]/g, "")
                                    .split(" ")
                                    .join("-")}-constituency-result/${con?.id}`,
                                  "_self"
                                )
                              }
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                textDecoration: "underline",
                              }}
                            >
                              {`${con?.constitutency_hi} (${con?.seat_name})`}
                            </td>
                            <td style={{ textAlign: "center", padding: "5px" }}>
                              {con?.party_name === "Result Awaited" ? (
                                "Result Awaited"
                              ) : dryRun == true ? (
                                <>
                                  <div>
                                    <img
                                      src={con?.party_logo}
                                      // style={{ marginRight: "20px" }}
                                      width="20px"
                                      height="20px"
                                    ></img>
                                  </div>
                                  <div>{con?.party_name}</div>
                                </>
                              ) : (
                                "Result Awaited"
                              )}
                            </td>
                            <td
                              className="winner-name"
                              style={{
                                padding: "6px",
                                // display: "flex",
                                fontSize: "15px",
                                justifyContent: "space-between",
                                textAlign: "center",
                              }}
                            >
                              {con?.candidate_name === "Result Awaited" ? (
                                "Result Awaited"
                              ) : dryRun == true ? (
                                <>
                                  {con?.seat_status && (
                                    <div>
                                      <img
                                        src={
                                          con?.seat_status === "WON"
                                            ? "https://static.thelallantop.com/images/post/1728033937028_thumbs_up.webp"
                                            : con?.seat_status === "TRAILING"
                                            ? "https://static.thelallantop.com/images/post/1728033833372_arrow_down.webp"
                                            : con?.seat_status === "LEADING"
                                            ? "https://static.thelallantop.com/images/post/1728033863072_arrow_up.webp"
                                            : "https://static.thelallantop.com/images/post/1728033907858_thumbs_down.webp"
                                        }
                                        // style={{ marginLeft: "20px" }}
                                        width="25px"
                                        height="25px"
                                      ></img>
                                    </div>
                                  )}
                                  <div 
                                  //add link here
                                   onClick={() =>{

                                    electionsData.ShowProfileFromListing && con?.candidate_name != 'NOTA' ?
                                    window.open(
                                      `${process.env.NEXT_PUBLIC_BASE_URL}/election/${
                                        props?.electionState
                                      }/candidate-${(
                                        con?.candidate_name || con?.name
                                      )
           
                                        ?.toLowerCase()
                                        .replace(/[^a-zA-Z ]/g, "")
                                        .split(" ")
                                        .join("-")}-${electionsData?.IDKeyInListing ? con?.[electionsData?.IDKeyInListing]   : '000'}-${
                                        con?.id}`,
                                      "_self"
                                    ) : ""
                                  }
                                  }
                                  style={electionsData?.ShowProfileFromListing  && con?.candidate_name != 'NOTA' ? {
                                    // textAlign: "center",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                    // fontSize: "18px" 
                                    maxWidth: "170px",
                                  }    :   { maxWidth: "170px",}}
                                  >{con?.candidate_name}</div>
                                </>
                              ) : (
                                "Result Awaited"
                              )}
                            </td>
                          </tr>
                        ) : 
                        (
                          <tr
                            key={index}
                            className={index % 2 !== 0 ? "oddColor" : ""}
                            style={{
                              letterSpacing: "normal",
                              fontSize: "15px",
                            }}
                          >
                            <td
                              onClick={() =>
                                window.open(
                                  `${process.env.NEXT_PUBLIC_BASE_URL}${
                                    router.asPath
                                  }/${con?.seat_name
                                    .toLowerCase()
                                    .replace(/[^a-zA-Z ]/g, "")
                                    .split(" ")
                                    .join("-")}-constituency-result/${con?.id}`,
                                  "_self"
                                )
                              }
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                textDecoration: "underline",
                              }}
                            >
                              {`${con?.constitutency_hi} (${con?.seat_name})`}
                            </td>
                            <td
                              style={{ paddingLeft: "30px", fontSize: "18px" }}
                            >
                              {con?.party_name === "Result Awaited" ? (
                                "Result Awaited"
                              ) : dryRun == true ? (
                                <>
                                  <img
                                    src={con?.party_logo}
                                    style={{ marginRight: "20px" }}
                                    width="25px"
                                    height="25px"
                                  ></img>
                                  {con?.party_name}
                                </>
                              ) : (
                                "Result Awaited"
                              )}
                            </td>
                            <td
                              className="winner-name"
                              style={{
                                padding: "10px",
                                display: "flex",
                                fontSize: "18px",
                                // justifyContent: "space-between",
                                justifyContent: "space-between",
                              }}
                            >
                              {con?.candidate_name === "Result Awaited" ? (
                                "Result Awaited"
                              ) : dryRun == true ? (
                                <>
                                  <div
                                    //add link here
                                    onClick={() =>{

                                      electionsData.ShowProfileFromListing  && con?.candidate_name != 'NOTA' ?
                                      window.open(
                                        `${process.env.NEXT_PUBLIC_BASE_URL}/election/${
                                          props?.electionState
                                        }/candidate-${(
                                          con?.candidate_name || con?.name
                                        )
             
                                          ?.toLowerCase()
                                          .replace(/[^a-zA-Z ]/g, "")
                                          .split(" ")
                                          .join("-")}-${electionsData?.IDKeyInListing ? con?.[electionsData?.IDKeyInListing]  : '000'}-${
                                          con?.id}`,
                                        "_self"
                                      ) : ""
                                    }
                                    }
                                    // style={{
                                    //   maxWidth: "170px",
                                    // }}
                                    style={electionsData?.ShowProfileFromListing  && con?.candidate_name != 'NOTA' ? {
                                      // textAlign: "center",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                      // fontSize: "18px" 
                                      maxWidth: "170px",
                                    }    :   { maxWidth: "170px",}}
                                  >
                                    {con?.candidate_name}
                                  </div>
                                  {con?.seat_status && (
                                    <div width="26%">
                                      <img
                                        src={
                                          con?.seat_status === "WON"
                                            ? "https://static.thelallantop.com/images/post/1728033937028_thumbs_up.webp"
                                            : con?.seat_status === "TRAILING"
                                            ? "https://static.thelallantop.com/images/post/1728033833372_arrow_down.webp"
                                            : con?.seat_status === "LEADING"
                                            ? "https://static.thelallantop.com/images/post/1728033863072_arrow_up.webp"
                                            : "https://static.thelallantop.com/images/post/1728033907858_thumbs_down.webp"
                                        }
                                        // style={{ marginLeft: "20px" }}
                                        width="25px"
                                        height="25px"
                                      ></img>
                                    </div>
                                  )}
                                </>
                              ) : (
                                "Result Awaited"
                              )}
                            </td>
                          </tr>
                        )}
                      </>
                    );
                  })}
              </table>
            </div>
          </div>
        </div>
        {/* <div>
          <iframe
            src="https://elections.mobiletak.com/elections/constituency-list-2019?website=llt"
            width="100%"
            height="500px"
          ></iframe>
        </div> */}
        <div className="electionYatra-outer-home" style={{ width: "100% " }}>
          <div className="electionYatra-header">
            <div>
              <img
                src="/assets/images/election-icon.png"
                width="35px"
                height="35px"
                alt="election-icon"
              ></img>
              <h2 style={{ marginLeft: "10px" , display : "inline-block" }}>विधानसभा चुनाव</h2>
            </div>
            <div
              className="election-aurDekhe"
              onClick={() => router.push("/election")}
            >
              <span style={{ marginRight: "10px" }}>और देखें </span>
              <img
                src="/assets/images/arrow.png"
                width="10px"
                height="10px"
              ></img>
            </div>
          </div>
          <div className="electionYatra-columns">
            {
              <a
                className="checkMobileOrNot"
                href={`${electionTopicData[0]?.permalink}`}
              >
                <div className="electionYatra-second election-mobile">
                  <div
                    className="electionYatra-second-top"
                    style={{ position: "relative" }}
                  >
                    <img src={electionTopicData[0]?.headingImageUrl}></img>
                    <i
                      className={electionTopicData[0]?.type == 'video' ? "icon-play-circle" : 'icon-cat-read'}
                      width="500px"
                      height="500px"
                      style={{
                        color: "white",
                        position: "absolute",
                        left: "2px",
                        bottom: "-5px",
                        width: "500px",
                      }}
                    ></i>
                  </div>
                  <div className="electionYatra-second-bottom">
                    <h3>{electionTopicData[0]?.title}</h3>
                  </div>
                </div>
              </a>
            }

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              {electionTopicData.slice(1).map((x, index) => {
                return (
                  <a href={`${x?.permalink}`} key={index}>
                    <div className="electionYatra-first">
                      <div className="electionYatra-first-div">
                        <div
                          style={{
                            // flex: "0 0 38%",
                            position: "relative",
                            justifyContent: "center",
                            alignContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={x?.headingImageUrl}
                            width="160px"
                            height="90px"
                          ></img>
                          <i
                            className={x?.type == 'video' ? "icon-play-circle" : 'icon-cat-read'}

                            style={{
                              color: "white",
                              position: "absolute",
                              left: "2px",
                              bottom: "-5px",
                            }}
                          ></i>
                        </div>
                        <div
                          className="electionYatra-first-div-right"
                          style={{ flex: "0 0 60%" }}
                        >
                          <div>
                            <div
                              style={{
                                overflow: "hidden",
                              }}
                            >
                              <h3
                                style={{
                                  display: "-webkit-box",
                                  lineHeight: "22px",
                                  WebkitLineClamp: "3",
                                  WebkitBoxOrient: "vertical",
                                  marginTop: "5px",
                                }}
                                className="chunav-yatra-small-title"
                              >
                                {x?.title}
                              </h3>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              gap: "1rem",
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>

            {
              <a
                style={{ width: "100%" }}
                className="checkDesktopOrNot"
                href={`${electionTopicData[0]?.permalink}`}
              >
                <div className="electionYatra-second election-desktop">
                  <div
                    className="electionYatra-second-top"
                    style={{ position: "relative" }}
                  >
                    <img src={electionTopicData[0]?.headingImageUrl}></img>
                    <i
                      className="icon-play-circle"
                      width="500px"
                      height="500px"
                      style={{
                        color: "white",
                        position: "absolute",
                        left: "2px",
                        bottom: "-5px",
                        width: "500px",
                      }}
                    ></i>
                  </div>
                  <div className="electionYatra-second-bottom">
                    <h3>{electionTopicData[0]?.title}</h3>
                  </div>
                </div>
              </a>
            }
          </div>
        </div>
        <Container align="center">
          <div className="container-row py-2" align="center">
            <p
              style={{
                fontSize: "11px",
                color: "#b7b7b7",
                textAlign: "center",
                marginBottom: "0px",
              }}
            >
              Advertisement
            </p>
            <div
              id={
                size.width > 600
                  ? "div-gpt-ad-1701945220410-1"
                  : "div-gpt-ad-1701946028239-1"
              }
              style={{
                minWidth: "300px",
                minHeight: size.width > 600 ? "100px" : "260px",
                display: "block !important",
                alignContent: "center",
                textAlign: "-webkit-center",
              }}
            >
              <script
                type="text/javascript"
                dangerouslySetInnerHTML={{
                  __html:
                    size.width > 600
                      ? `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})`
                      : `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})`,
                }}
              ></script>
            </div>
          </div>{" "}
        </Container>
      </div>
    </>
  );
}

export default KaunJeetaD;
